import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { Sparkles } from "lucide-react";

export default function AtlasWhatIs() {
  const { t, messages } = useI18n();
  const paragraphs = messages?.whatIs?.paragraphs || [];
  return (
    <section
      id="que-es-atlas"
      data-testid="atlas-whatis"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-[#6B46C1] uppercase tracking-[0.18em] text-xs font-bold">
          <Sparkles size={14} />
          <span>{t("whatIs.badge")}</span>
        </div>
        <h2
          data-testid="whatis-title"
          className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] leading-tight font-extrabold text-slate-900"
        >
          {t("whatIs.titleA")}{" "}
          <span className="text-[#6B46C1]">{t("whatIs.titleB")}</span>
        </h2>
        <div className="mt-6 space-y-4 text-slate-700 text-base sm:text-lg leading-relaxed">
          {paragraphs.map((p, i) => (
            <p key={i} data-testid={`whatis-p-${i}`}>
              {renderInline(p)}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}

// Renders simple **bold** markers inline.
function renderInline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return (
        <strong key={i} className="font-semibold text-slate-900">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
